import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import EditorialMarquee from "@/components/landing/EditorialMarquee";
import About from "@/components/landing/About";
import WhyHariOmBol from "@/components/landing/WhyHariOmBol";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import DownloadCTA from "@/components/landing/DownloadCTA";
import Footer from "@/components/landing/Footer";
import DownloadPopup from "@/components/landing/DownloadPopup";
import MobileStickyCTA from "@/components/landing/MobileStickyCTA";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const handleAnchor = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (id.length <= 1) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", handleAnchor);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", handleAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App" data-testid="landing-page">
      <div className="grain-overlay" />
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <About />
        <WhyHariOmBol />
        <Pricing />
        <FAQ />
        <DownloadCTA />
      </main>
      <Footer />
      <MobileStickyCTA />
      <DownloadPopup />
    </div>
  );
}
